export const LOCALE = {
  en: 'english',
  ja: 'japanese',
  vi: 'vietnamese'
}



// WEBPACK FOOTER //
// ./src/enum/locale.enum.js